import { ColorSystemOptions } from '@mui/material/styles';
import { colors } from '../variables/colors';

export const lightTheme: ColorSystemOptions = {
  palette: {
    mode: 'light',
    ...colors,
    common: {
      black: colors.black,
      white: colors.white,
    },
    primary: {
      main: '#8B369E',
    },
    secondary: {
      main: colors.grey[200],
    },
    background: {
      default: colors.white,
      paper: colors.white,
    },
    text: {
      primary: colors.black,
      secondary: colors.grey[600],
    },
  },
};
